/**
 * Game-type display metadata — name + description per numeric game-type id.
 *
 * Shared between the lobby's `logon-panel` and the in-game `game-selector`
 * so the two UIs can't drift on what FFA / CTF / BTR are labelled. The
 * numeric keys mirror the server-side type ids exposed by ab-protocol's
 * `GAME_TYPES` enum (FFA=1, CTF=2, BTR=3); 4 is a local Development bucket
 * that doesn't ship on production servers but appears in dev environments.
 */
export const GAME_TYPE_META: Record<number, { name: string; description: string }> = {
  1: {
    name: 'Free For All',
    description: 'Everyone versus everyone deathmatch. No teams.',
  },
  2: {
    name: 'Capture The Flag',
    description:
      'Players split into 2 teams. 2 flags are placed inside each base. The objective is to move the enemy flag from their base to your base.',
  },
  3: {
    name: 'Battle Royale',
    description:
      'Players spawn at random locations all across the map. Destroyed players will not respawn. Last player standing wins.',
  },
  4: {
    name: 'Development',
    description: 'Game environments for development and testing.',
  },
};
